import React from "react";
import { Card } from "tea-component";
import './index.scss';
import SvgIcon from "@home/components/SvgIcon";
import classNames from "classnames";
import { useParams } from "umi";
import { useLocal } from "@/pages/dashboard/utils/customHook";
import { getLanguage } from "@home/utils/common";
import { valueTypeArray } from "@/pages/benchmark/utils/utils";

interface MetricDetailCard {

  className?: string;
  style?: React.CSSProperties;
  config:{  
    titleEn: string;
    titleCn: string;
  };
  data?: any;
}

export default function MetricDetailTips(props: MetricDetailCard) {
  const { 
    style, 
    className,
    config,
  } = props;
  const {titleEn, titleCn}=config;
  const { metric } = useParams<{ metric: string; }>();
  const { isEN } = useLocal();
  const { metricConfig } = props?.data ?? {};
  const metricConfigData = metricConfig?.[metric] ?? {};
  const { tips_en: tipEn, tips_cn: tipsCn, value_type: valueType, } = metricConfigData;
  const valueArray = valueTypeArray(valueType);

  // 如果没提tips就不渲染组件
  if (!valueArray.includes('tips')) {
    return null;
  }

  return (
    <Card className={classNames('dbb-metric-tip', className)} style={style}>
      <Card.Header className="dbb-metric-tip-title">
        <SvgIcon type="icon-lamp" className="dbb-metric-tip-icon" /> 
        <span>{getLanguage(isEN, titleEn, titleCn)}</span>
      </Card.Header>
      <Card.Body>
        <div dangerouslySetInnerHTML={{ __html: getLanguage(isEN, tipEn, tipsCn)?.replaceAll('\\n', '<br/>') }} />
      </Card.Body>
    </Card>
  );
}